import { r as registerInstance, h, a as Host } from './index-744b06c7.js';

const rCloseButtonCss = "r-close-button{display:block;position:relative}button{cursor:pointer;border:none;background:none;padding:0;margin:0}.button-container{width:48px;height:48px;align-content:center}.icon-close{width:16px;height:16px}.hover-state{transition:opacity 0.3s ease-in-out}@media (pointer: fine){.hover-state:hover{opacity:0.6}}";
const RCloseButtonStyle0 = rCloseButtonCss;

const RCloseButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.handleClose = undefined;
    }
    render() {
        return (h(Host, { key: '1570f4bdb66806800b5277a8fbc9a1f6a84c7794' }, h("button", { key: 'f503dcf436ad00e95623dd101ee8a332d2c0fa66', class: "close-button hover-state", "aria-label": "Close", onClick: this.handleClose }, h("div", { key: '8392ef2f12218b2483bf31ad5c2feec606892cab', class: "button-container" }, h("img", { key: '9cae56cabb934ef77f741bd59f0387a8cffa7e28', class: "icon-close", src: "https://assets.ritual.com/icons/close-24x24.svg", alt: "Close" })))));
    }
};
RCloseButton.style = RCloseButtonStyle0;

export { RCloseButton as r_close_button };

//# sourceMappingURL=r-close-button.entry.js.map